// extracted by mini-css-extract-plugin
export default {"label":"aRALe","description":"amEQG","country":"QbDg5","filterInput":"E2Hwi","noMatches":"qZZ89","container":"rOtb9","countryList":"Uu_Pi"};